export const vergabeWissenSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "SubmenuLink",
          label: "News",
          link: "/vergabe-wissen/news",
        },
        {
          type: "SubmenuLink",
          label: "Lexikon",
          link: "/vergabe-wissen/lexikon",
        },
        {
          type: "SubmenuLink",
          label: "Blog",
          link: "/vergabe-wissen/blog",
        },
        {
          type: "SubmenuLink",
          label: "Quiz",
          link: "/vergabe-wissen/quiz",
        },
        {
          type: "CTAButton",
          label: "Aktuelle Ausschreibungen",
          link: "/ausschreibungsdienste",
        },
      ]
    : [
        {
          type: "DropdownMenuMobile",
          label: "Themen",
          page: "vergabe-wissen",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "News",
              link: "/vergabe-wissen/news",
            },
            {
              type: "SubmenuLink",
              label: "Lexikon",
              link: "/vergabe-wissen/lexikon",
            },
            {
              type: "SubmenuLink",
              label: "Blog",
              link: "/vergabe-wissen/blog",
            },
            {
              type: "SubmenuLink",
              label: "Quiz",
              link: "/vergabe-wissen/quiz",
            },
          ],
        },
      ]
